module.exports = __webpack_public_path__ + "img/HA1502-25.a5615353.jpg";